// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.section-shaped {
  min-height: calc(100vh - 70px);
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.display-4 {
  font-size: 1.8rem;
  font-weight: 400;
}

.display-4 span {
  display: inline;
}

.bg-card {
  background-color: #f4f5f7;
}

.terms-checkbox-container {
  padding-bottom: 1.34375em;
}

.checkbox-text-error {
  color: #f44336;
}

.fill-gray {
  fill: #f4f5f7;
}

.text-muted {
  color: #51585e !important;
}

.form-field-space {
  margin-top: 7px;
  margin-bottom: 7px;
}

.forgot-password-link {
  color: #3f51b5;
  text-decoration: none; /* Remove default underline */
  cursor: pointer; /* Show pointer cursor on hover */
}

.forgot-password-link:hover {
  text-decoration: underline; /* Underline on hover */
  color: #3f51b5;
}`, "",{"version":3,"sources":["webpack://./src/app/nonAdmin/login/login.component.scss"],"names":[],"mappings":"AAAA;EACI,8BAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AACJ;;AAEA;EACI,iBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,eAAA;AACJ;;AAEA;EACI,yBAAA;AACJ;;AAEA;EACI,yBAAA;AACJ;;AAGA;EACI,cAAA;AAAJ;;AAGA;EACI,aAAA;AAAJ;;AAGA;EACI,yBAAA;AAAJ;;AAGA;EACE,eAAA;EACA,kBAAA;AAAF;;AAGA;EACE,cAAA;EACA,qBAAA,EAAA,6BAAA;EACA,eAAA,EAAA,iCAAA;AAAF;;AAEA;EACE,0BAAA,EAAA,uBAAA;EACA,cAAA;AACF","sourcesContent":[".section-shaped {\r\n    min-height: calc(100vh - 70px);\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n}\r\n\r\n.display-4 {\r\n    font-size: 1.8rem;\r\n    font-weight: 400;\r\n}\r\n\r\n.display-4 span{\r\n    display: inline;\r\n}\r\n\r\n.bg-card {\r\n    background-color: #f4f5f7;\r\n}\r\n\r\n.terms-checkbox-container {\r\n    padding-bottom: 1.34375em;\r\n}\r\n\r\n\r\n.checkbox-text-error {\r\n    color: #f44336;\r\n}\r\n\r\n.fill-gray {\r\n    fill: #f4f5f7;\r\n}\r\n\r\n.text-muted {\r\n    color: #51585e !important;\r\n}\r\n\r\n.form-field-space {\r\n  margin-top: 7px ;\r\n  margin-bottom: 7px;\r\n\r\n}\r\n.forgot-password-link {\r\n  color: #3f51b5;\r\n  text-decoration: none; /* Remove default underline */\r\n  cursor: pointer; /* Show pointer cursor on hover */\r\n}\r\n.forgot-password-link:hover {\r\n  text-decoration: underline; /* Underline on hover */\r\n  color: #3f51b5;\r\n\r\n}\r\n\r\n// .password-toggle-btn {\r\n//     color: #3f51b5 !important;\r\n// }\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
